// ⚠️ MIRRORED FILE — keep byte-identical across restomag-website and restomag-events (repos can't share code).
// Shared definition of the cross-site menu + UTM helper for restomag.com ⇄ events.restomag.com.

export const MAIN_ORIGIN = "https://www.restomag.com";
export const EVENTS_ORIGIN = "https://events.restomag.com";

/** Append cross-site UTM params to an absolute URL. */
export function withUtm(url: string, source: string, medium: string): string {
  const u = new URL(url);
  u.searchParams.set("utm_source", source);
  u.searchParams.set("utm_medium", medium);
  u.searchParams.set("utm_campaign", "cross_site");
  return u.toString();
}

export type CrossNavItem = {
  label: string;
  /** Final resolved href for the site doing the rendering. */
  href: string;
  /** true → render an <a> (cross-domain); false → render an in-app route link. */
  external: boolean;
  /** true → this item represents the current site (highlight as active by default). */
  selfActive: boolean;
};

/** Menu as resolved for restomag.com (the main site). */
export function buildMainNav(): CrossNavItem[] {
  return [
    { label: "Home", href: "/", external: false, selfActive: true },
    { label: "Features", href: "/features", external: false, selfActive: false },
    { label: "Events", href: withUtm(`${EVENTS_ORIGIN}/`, "restomag", "nav"), external: true, selfActive: false },
    //{ label: "Pricing", href: "/pricing", external: false, selfActive: false },
    { label: "About", href: "/about", external: false, selfActive: false },
    { label: "Contact", href: "/contact", external: false, selfActive: false },
  ];
}

/** Menu as resolved for events.restomag.com (the events site). */
export function buildEventsNav(): CrossNavItem[] {
  const main = (path: string) => withUtm(`${MAIN_ORIGIN}${path}`, "events", "nav");
  return [
    { label: "Home", href: main("/"), external: true, selfActive: false },
    { label: "Features", href: main("/features"), external: true, selfActive: false },
    { label: "Events", href: "/", external: false, selfActive: true },
    //{ label: "Pricing", href: main("/pricing"), external: true, selfActive: false },
    { label: "About", href: main("/about"), external: true, selfActive: false },
    { label: "Contact", href: main("/contact"), external: true, selfActive: false },
  ];
}
